// Mirror of backend AUTH_POLICY (spec 2026-06-03-application-only-signup). Cosmetic
// gating only — the backend is the enforcement. Keep in sync with
// backend/src/config/authPolicy.js, which carries the full rationale.
//
// The "review ~2026-09-03" that used to sit on this line is RETIRED — that review
// was held early and closed (DECISIONS 2026-08-11, ledger D-11 / #576).
//
// RETIRED (#1017 architecture-review addendum, Task 11): `inviteRequired` used
// to live here too, flipped `true` in lockstep with the backend on 2026-08-11
// (#582). It is gone now, not renamed. The gate it mirrored is driven at
// runtime by `ConfigSettings.application_codes_mode` (#1018) on the backend —
// a staff-settable, audit-logged tri-state with no redeploy required to
// change it, which a frozen frontend constant could never mirror correctly.
// `ApplyLandingPage` reads the live mode from the public, rate-limited
// `GET /api/applications/gate` endpoint instead (see
// backend/src/routes/applications.js) — that is the one place this posture
// is decided now. `docs/DECISIONS.md` carries a 2026-08-23 entry superseding
// both the 2026-08-10 (D-2) and 2026-08-11 (D-11) entries this file used to
// point to.
export const AUTH_POLICY = {
  selfSignupEnabled: false,
  disabledRoles: [] as string[],
} as const;
